import React, { useState, useEffect } from 'react';
import '../styles/Configuracoes.css';


function Configuracoes({ onClose, onRestaurar }) {
  const [logo, setLogo] = useState(null);
  const [workerUrl, setWorkerUrl] = useState('');
  const [authToken, setAuthToken] = useState('');
  const [blingApiKey, setBlingApiKey] = useState('');
  const [salvo, setSalvo] = useState(false);
  const [importStatus, setImportStatus] = useState(''); // '' | 'ok' | 'erro'
  const [recuperandoStatus, setRecuperandoStatus] = useState(''); // '' | 'recuperando' | 'ok' | 'erro'
  const [recuperandoErro, setRecuperandoErro] = useState('');

  useEffect(() => {
    const l = localStorage.getItem('logo');
    if (l) setLogo(l);
    const w = localStorage.getItem('workerUrl');
    if (w) setWorkerUrl(w);
    const t = localStorage.getItem('authToken');
    if (t) setAuthToken(t);
    const b = localStorage.getItem('blingApiKey');
    if (b) setBlingApiKey(b);
  }, []);

  const handleLogo = (e) => {
    const file = e.target.files[0] || (e.dataTransfer && e.dataTransfer.files[0]);
    if (!file || !file.type.startsWith('image/')) return;
    const reader = new FileReader();
    reader.onloadend = () => setLogo(reader.result);
    reader.readAsDataURL(file);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    handleLogo(e);
  };

  const exportarBackup = () => {
    const produtos = localStorage.getItem('products') || '[]';
    const dados = {
      exportadoEm: new Date().toISOString(),
      versao: 1,
      produtos: JSON.parse(produtos),
    };
    const blob = new Blob([JSON.stringify(dados, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    const data = new Date().toLocaleDateString('pt-BR').replace(/\//g, '-');
    a.href = url;
    a.download = `catalogo-backup-${data}.json`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const importarBackup = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => {
      try {
        // Remove BOM se houver
        const texto = ev.target.result.replace(/^﻿/, '');
        const dados = JSON.parse(texto);
        // Aceita: array direto, {produtos:[]}, {data:[]}
        let lista = null;
        if (Array.isArray(dados)) lista = dados;
        else if (Array.isArray(dados.produtos)) lista = dados.produtos;
        else if (Array.isArray(dados.data)) lista = dados.data;
        if (!lista || lista.length === 0) throw new Error('Vazio ou inválido');
        localStorage.setItem('products', JSON.stringify(lista));
        setImportStatus('ok');
        if (onRestaurar) onRestaurar(lista);
        setTimeout(() => { setImportStatus(''); onClose(); }, 1500);
      } catch (err) {
        console.error('Erro ao importar:', err);
        setImportStatus('erro');
        setTimeout(() => setImportStatus(''), 4000);
      }
    };
    reader.readAsText(file);
    e.target.value = '';
  };

  // Fetch com timeout
  const fetchComTimeout = (url, opcoes = {}, segundos = 10) => {
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), segundos * 1000);
    return fetch(url, { ...opcoes, signal: ctrl.signal })
      .finally(() => clearTimeout(timer));
  };

  // Recupera os produtos direto do Cloudflare via endpoint /catalog
  const recuperarDoSite = async () => {
    const wUrl = (localStorage.getItem('workerUrl') || '').replace(/\/$/, '');
    const aToken = localStorage.getItem('authToken') || '';

    if (!wUrl || !aToken) {
      alert('Configure a URL do Worker e o Token primeiro.');
      return;
    }

    setRecuperandoStatus('recuperando');
    setRecuperandoErro('');

    try {
      const resp = await fetchComTimeout(`${wUrl}/catalog`, {
        headers: { 'X-Auth-Token': aToken },
      }, 8);

      if (!resp.ok) {
        throw new Error(`Worker retornou erro ${resp.status}. Verifique se o Worker foi atualizado no Cloudflare.`);
      }

      const data = await resp.json();

      if (data && data.erro) throw new Error(data.erro);

      if (!Array.isArray(data) || data.length === 0) {
        throw new Error('Catálogo ainda não foi salvo no Cloudflare. Clique em "Salvar & Publicar" no app primeiro para gravar o catálogo na nuvem.');
      }

      localStorage.setItem('products', JSON.stringify(data));
      if (onRestaurar) onRestaurar(data);
      setRecuperandoStatus('ok');
      setTimeout(() => { setRecuperandoStatus(''); onClose(); }, 1500);

    } catch (err) {
      setRecuperandoErro(err.message || 'Erro ao conectar com o Cloudflare.');
      setRecuperandoStatus('erro');
      setTimeout(() => { setRecuperandoStatus(''); setRecuperandoErro(''); }, 8000);
    }
  };

  const salvar = () => {
    if (logo) localStorage.setItem('logo', logo);
    else localStorage.removeItem('logo');

    if (workerUrl.trim()) localStorage.setItem('workerUrl', workerUrl.trim());
    else localStorage.removeItem('workerUrl');

    if (authToken.trim()) localStorage.setItem('authToken', authToken.trim());
    else localStorage.removeItem('authToken');

    if (blingApiKey.trim()) localStorage.setItem('blingApiKey', blingApiKey.trim());
    else localStorage.removeItem('blingApiKey');

    setSalvo(true);
    setTimeout(() => { setSalvo(false); onClose(); }, 1200);
  };

  const temWorker = !!(localStorage.getItem('workerUrl') && localStorage.getItem('authToken'));

  return (
    <div className="cfg-overlay" onClick={onClose}>
      <div className="cfg-modal" onClick={e => e.stopPropagation()}>
        <button className="cfg-close" onClick={onClose}>✕</button>
        <h2>Configurações</h2>

        <div className="cfg-section">
          <label className="cfg-label">Logo do site</label>
          <div
            className="cfg-drop"
            onDragOver={e => e.preventDefault()}
            onDrop={handleDrop}
          >
            {logo
              ? <img src={logo} alt="Logo" className="cfg-logo-preview" />
              : <p>Arraste a logo aqui ou</p>}
            <label className="cfg-file-btn">
              {logo ? 'Trocar logo' : 'Selecionar arquivo'}
              <input type="file" accept="image/*" onChange={handleLogo} style={{ display: 'none' }} />
            </label>
          </div>
          {logo && (
            <button className="cfg-remover" onClick={() => setLogo(null)}>
              ✕ Remover logo
            </button>
          )}
        </div>

        <div className="cfg-section">
          <label className="cfg-label">Publicação automática no Cloudflare</label>
          <div className="cfg-field">
            <label className="cfg-field-label">URL do Worker</label>
            <input
              type="url"
              className="cfg-input"
              placeholder="https://mogi-outlet.SEU-USUARIO.workers.dev"
              value={workerUrl}
              onChange={e => setWorkerUrl(e.target.value)}
            />
          </div>
          <div className="cfg-field">
            <label className="cfg-field-label">Token secreto</label>
            <input
              type="password"
              className="cfg-input"
              placeholder="Mesmo token configurado no Worker"
              value={authToken}
              onChange={e => setAuthToken(e.target.value)}
            />
          </div>
          <p className="cfg-hint">
            Preencha para ativar o botão "Publicar Site" no app.
          </p>
        </div>

        {/* Recuperar do site publicado */}
        {temWorker && (
          <div className="cfg-section">
            <label className="cfg-label">Recuperar produtos do site publicado</label>
            <p className="cfg-hint" style={{ marginBottom: 12 }}>
              Busca os produtos salvos no Cloudflare e restaura no app. Use se o catálogo local ficou diferente do site.
            </p>
            <button
              className={`cfg-recuperar-btn ${recuperandoStatus}`}
              onClick={recuperarDoSite}
              disabled={recuperandoStatus === 'recuperando'}
            >
              {recuperandoStatus === 'recuperando' ? '⏳ Buscando no Cloudflare...'
               : recuperandoStatus === 'ok'         ? '✅ Produtos restaurados!'
               : recuperandoStatus === 'erro'        ? '❌ Não encontrado'
               : '☁️ Recuperar do site publicado'}
            </button>
            {recuperandoErro && (
              <p className="cfg-hint" style={{ color: '#dc2626', marginTop: 8 }}>
                {recuperandoErro}
              </p>
            )}
          </div>
        )}

        <div className="cfg-section">
          <label className="cfg-label">Backup do catálogo</label>
          <p className="cfg-hint" style={{ marginBottom: 12 }}>
            Exporte um backup local (.json) como segurança extra.
          </p>
          <div className="cfg-backup-btns">
            <button className="cfg-backup-btn" onClick={exportarBackup}>
              💾 Exportar backup (.json)
            </button>
            <label className={`cfg-backup-btn importar ${importStatus}`}>
              {importStatus === 'ok'   ? '✅ Importado!'
               : importStatus === 'erro' ? '❌ Arquivo inválido'
               : '📂 Importar backup'}
              <input
                type="file"
                accept=".json,application/json"
                onChange={importarBackup}
                style={{ display: 'none' }}
              />
            </label>
          </div>
        </div>

        <button className={`cfg-salvar ${salvo ? 'ok' : ''}`} onClick={salvar}>
          {salvo ? '✅ Salvo!' : 'Salvar'}
        </button>
      </div>
    </div>
  );
}

export default Configuracoes;
